module.exports = __webpack_public_path__ + "img/q_hand_h.e12458e9.gif";